import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo, } from "react";
const ApplicationContext = createContext(null);
export const ApplicationContextProvider = ({ application, capabilities, children, currentCompany, screen, session, switchCompany, }) => {
    const value = useMemo(() => ({
        application,
        capabilities,
        currentCompany,
        ...(screen ? { screen } : {}),
        session,
        ...(switchCompany ? { switchCompany } : {}),
    }), [
        application,
        capabilities,
        currentCompany,
        screen,
        session,
        switchCompany,
    ]);
    return (_jsx(ApplicationContext.Provider, { value: value, children: children }));
};
export const useApplicationContext = () => {
    const value = useContext(ApplicationContext);
    if (!value) {
        throw new Error("ApplicationContextProvider is missing.");
    }
    return value;
};
//# sourceMappingURL=context.js.map